const Cookies = window.Cookies
const scopeName = 'codelab'
/**
 * 用戶模塊
 */
const user = {
    namespaced: true,
    state: {
        session: '', // websocket連線session信息
        userInfo: null,
        token: Cookies.get('token'),
        userId: '',
        name: '',
        teamId: '',
        currentTeam: null,
        teams: [],
        tools: [],
        count: 55
    },
    getters: {
        currentConncetTypeGetter (state) {
            if (state?.userInfo?.currentTeam?.isRmsScope) {
                return 'rms'
            }
            if (state?.userInfo?.currentTeam?.isBiz) {
                return 'white'
            }
        
            return ''
        },
        teachFeatureGetter (state) {
            return state?.userInfo?.currentTeam?.teachFeature
        },
        hansRmsScope (state) {
            return !!state.userInfo?.currentTeam?.isRmsScope
        }
    },
    mutations: {
        updateUserInfo (state, payload) {
            state.name = payload.name
            state.userId = payload.userId
            state.teams = payload.team
            state.teamId = payload.teamId
            state.currentTeam = payload.currentTeam
            state.tools = payload.currentTeam.scope.filter(item => item.name !== scopeName)
            state.userInfo = payload
            state.token = Cookies.get('token')
        },
        setWebsocketSession (state, { clientId, sessionToken }) {
            state.session = { clientId, sessionToken }
        }
    },
    actions: {

    }
}
export default user
